import type { PropsWithChildren } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import _BaseLabel from './_BaseLabel'

export type HighlightLabelVariant = 'default' | 'branded'

const HighlightLabelElement = styled(_BaseLabel)`
  &.variant-default {
    background-color: var(--palette-highlight-primary-normal-background);
    border-color: var(--palette-highlight-primary-normal-foreground);
    color: var(--palette-highlight-primary-normal-contrast);
  }

  &.variant-branded {
    background-color: var(--palette-highlight-primary-dark-background);
    border-color: var(--palette-highlight-primary-dark-foreground);
    color: var(--palette-highlight-primary-dark-contrast);
  }
`

interface Props {
  className?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
  format?: React.ComponentProps<typeof _BaseLabel>['format']
  variant?: HighlightLabelVariant
}

/**
 * Documentation: <https://aussiecommerce.atlassian.net/wiki/spaces/UXUI/pages/4504289338/Label>
 */
function HighlightLabel({
  className,
  variant = 'default',
  ...labelProps
}: PropsWithChildren<Props>) {
  return <HighlightLabelElement
    className={clsx(
      className,
      `variant-${variant}`,
    )}
    {...labelProps}
  />
}

export default HighlightLabel
